export default __webpack_public_path__ + "static/media/icon_provider_location.10454627.svg";